import {brandingService} from "@/modules/common/services";

const VCITA_DEFAULT = {
  use_login_with_code: true,
  hide_sign_up: false,
  logo_path: () => import('@/assets/images/vcita-logo-white.svg'),
  new_logo_path: () => import('@/assets/images/new-vcita-logo.svg')
}

const VCITA_DEFAULT_COLORS = {
  primary_color: "#0c315e",
  secondary_color: "#0093B8",
  text_color: "#ffffff",
  brand_color: "#4DA51E"
}

const isWhite = (color) => {
  return color === '#ffffff' || color === 'rgb(255, 255, 255)'
}

const state = {
  branding: {},
  operatorBrand: {}
};

const getters = {
    branding: state => state.branding,
    secondaryColor: state => state.branding && state.branding.secondary_color || VCITA_DEFAULT_COLORS.secondary_color,
    primaryColor: state => state.branding && state.branding.primary_color || VCITA_DEFAULT_COLORS.primary_color,
    textColor: state => state.branding && state.branding.text_color || VCITA_DEFAULT_COLORS.text_color,
    isSecondaryColorSet: (state, getters) => !!getters.secondaryColor,
    hoverColor: (state, getters) => isWhite(getters.secondaryColor) ? getters.textColor : getters.secondaryColor,
    brandColor: state => state.branding.brand_color || VCITA_DEFAULT_COLORS.brand_color,
    isBranded: state => state.branding && (state.branding.whitelabel || state.branding.co_branded_managed),
    operatorBrand: state => state.operatorBrand,
    getPoweredBy: state => {
      return state?.operatorBrand?.powered_by
    },
    isBrandDarkMode: state => {
      return state.operatorBrand?.colors?.primary === '#000000'
    },
    getPoweredByImage: (state, getters) => {
      return getters.isBrandDarkMode ? state.operatorBrand?.powered_by?.parent_logo_bright : state.operatorBrand?.powered_by?.parent_logo_dark
    },
    getProvidedByImage: (state, getters) => {
      return getters.isBrandDarkMode ? state.operatorBrand?.powered_by?.intandem_logo_bright : state.operatorBrand?.powered_by?.intandem_logo_dark
    },
    darkPoweredByLogos: (state) => {
      const parent = state.operatorBrand?.powered_by?.parent_logo_dark
      const intandem = state.operatorBrand?.powered_by?.intandem_logo_dark
      if(!parent && !intandem) {
        return null
      }
      return {
        parent,
        intandem,
      }
    },
    poweredByLogos: (state, getters) => {
      if(!getters.getPoweredByImage && !getters.getProvidedByImage) {
        return null
      }
      return {
        parent: getters.getPoweredByImage,
        intandem: getters.getProvidedByImage,
      }
    },
};

const mutations = {
  setBrand: (state, brand) => {
    state.branding = brand;
  },
  setOperatorBrand: (state, operatorBrand) => {
    state.operatorBrand = operatorBrand
  },

};

const actions = {
  initOperatorBrand: async ({commit, state}) => {
    if(Object.keys(state.operatorBrand).length) {
      return;
    }
    if(state.branding && (state.branding.whitelabel || state.branding.co_branded_managed)) {
      const response = await brandingService.getOperatorBranding()
      commit('setOperatorBrand', response.data)
    }
  },
  initBrand: async ({commit}, {brand}) => {
    brand = brand || {}
    const brandObj = (brand.whitelabel || brand.co_branded_managed) ? brand : {...brand, ...VCITA_DEFAULT}
    commit("setBrand", brandObj);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
